<template>
  <div>
    <el-card style="margin: 20px; width: 100%; height: 100%;min-height: 75vh;">
      <el-scrollbar>
        <div class="tableBox" style="min-height: 75vh;">
          <div class="treebox">
            <div style="width: 300px">
              <com-tree ref="tree" :selectVal="selectTree" @classify="classify"></com-tree>
            </div>
          </div>
          <div style="margin: 20px; width: 100%">
            <div class="header">
              <el-button
                :disabled="canAdd"
                style="margin-left: 20px"
                plain
                type="primary"
                @click="goadd"
              >添加</el-button>
              <el-button
                :loading="delLoading"
                @click="godel"
                :disabled="delShow"
                size="mini"
                type="danger"
                plain
              >
                <i class="el-icon-delete-solid"></i>删除
              </el-button>
              <el-button
                :loading="upLoading"
                :disabled="delShow"
                style="margin-left: 20px"
                type="primary"
                plain
                @click="upStateTop"
              >上架</el-button>
              <el-button
                :loading="downLoading"
                :disabled="delShow"
                style="margin-left: 20px"
                type="primary"
                plain
                @click="upStateBottom"
              >下架</el-button>
              <el-button
                :loading="hotLoading"
                :disabled="delShow"
                style="margin-left: 20px"
                type="primary"
                plain
                @click="upHot(true)"
              >标记</el-button>
              <el-button
                :loading="noHotLoading"
                :disabled="delShow"
                style="margin-left: 20px"
                type="primary"
                plain
                @click="upHot(false)"
              >取消标记</el-button>
              <el-button style="margin-left: 20px" type="primary" plain @click="importFaq()">导入</el-button>
              <el-button style="margin-left: 20px" type="primary" plain @click="exportFaq()">导出</el-button>
            </div>
            <el-table
              @sort-change="changeSort"
              @selection-change="handleSelectionChange"
              v-loading="loading"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
              :data="problemList"
              style="width: 100%; margin-top: 20px"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column type="index" width="80px" label="排序"></el-table-column>
              <el-table-column width="200" prop="title" label="问题名称">
                <template slot-scope="scope">
                  <div>
                    <el-popover
                      placement="top-start"
                      width="auto"
                      trigger="hover"
                      :content="scope.row.title"
                    >
                      <div class="linkTip" slot="reference">{{ scope.row.title }}</div>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="classifyName" label="所属目录" width="150">
                <template slot-scope="scope">
                  <div>
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover"
                      :content="scope.row.classifyName"
                    >
                      <div class="linkTips" slot="reference">{{ scope.row.classifyName }}</div>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <el-table-column sortable align="center" width="115" prop="usolveCount" label="未解决投票">
                <template slot-scope="scope">
                  <div>
                    <el-button
                      @click="openMyChart(scope.row)"
                      type="text"
                    >{{ scope.row.usolveCount ? scope.row.usolveCount : '0' }}</el-button>
                  </div>
                </template>
              </el-table-column>
              <!-- 1：上架 2：下架 -->
              <el-table-column width="115" sortable align="center" prop="solveCount" label="已解决投票"></el-table-column>
              <el-table-column width="105" align="center" sortable prop="inquiryCount" label="浏览总数">
                <template slot-scope="scope">
                  <div>{{ scope.row.inquiryCount ? scope.row.inquiryCount : '0' }}</div>
                </template>
              </el-table-column>
              <el-table-column width="105" prop="solveCount" label="未解决备注">
                <template slot-scope="scope">
                  <div>
                    <el-button @click="openProblemsInfo(scope.row)" type="text">
                      {{
                        scope.row.remarkQuestions
                          ? scope.row.remarkQuestions
                          : '0'
                      }}
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="hot" label="标红">
                <template slot-scope="scope">
                  <div>{{ scope.row.hot ? '已标记' : '默认' }}</div>
                </template>
              </el-table-column>
              <el-table-column
                :filters="[{ text: '上架', value: '1' }, { text: '下架', value: '2' }]"
                :filter-method="filterHandler"
                prop="state"
                label="状态"
              >
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.state == 1" style="color: green">上架</span>
                    <span v-if="scope.row.state == 2" style="color: red">下架</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: left;
                    "
                  >
                    <el-button @click="top(scope.row)" type="text" size="small">上架</el-button>
                    <el-button @click="bottom(scope.row)" type="text" size="small">下架</el-button>
                    <el-button
                      :disabled="scope.row.state == 1"
                      @click="edit(scope.row)"
                      type="text"
                      size="small"
                    >编辑</el-button>
                    <el-button @click="see(scope.row)" type="text" size="small">查看</el-button>
                    <!--                  <el-dropdown trigger="click">-->
                    <!--                    <span style="color: #1890FF; font-size: 12px;cursor: pointer;" class="el-dropdown-link">更多</span>-->
                    <!--                    <el-dropdown-menu slot="dropdown">-->
                    <!--                      <el-dropdown-item @click.native="edit(scope.row)" icon="el-icon-edit">编辑</el-dropdown-item>-->
                    <!--                      <el-dropdown-item @click.native="see(scope.row)" icon="el-icon-circle-plus">查看</el-dropdown-item>-->
                    <!--                    </el-dropdown-menu>-->
                    <!--                  </el-dropdown>-->
                    <div v-if="sortShow" style="display: flex; align-items: center">
                      <img
                        @click="tomove(scope.$index, true, scope.row)"
                        style="width: 26px; height: 26px; cursor: pointer"
                        src="../../icons/icon/page_icon_up_nor@2x.png"
                        alt
                      />
                      <img
                        @click="tomove(scope.$index, false, scope.row)"
                        style="width: 26px; height: 26px; cursor: pointer"
                        src="../../icons/icon/page_icon_down_nor@2x.png"
                        alt
                      />
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div style="text-align: right; margin: 10px 0">
          <el-pagination
            background
            :small="true"
            @prev-click="prevPage"
            @next-click="nextPage"
            @current-change="currentPage"
            layout="prev, pager, next"
            :total="pageTotal"
          ></el-pagination>
        </div>
      </el-scrollbar>
    </el-card>
    <div class="dialogbox">
      <a-modal
        width="800px"
        :title="editShow ? '编辑/查看' : '添加'"
        :visible="addShow"
        :confirm-loading="doaddloading"
        @ok="doadd"
        okText="确认"
        cancelText="取消"
        @cancel="closeModal"
        :ok-button-props="{ props: { disabled: seeShow ? true : false } }"
      >
        <el-form :disabled="seeShow" label-width="80px" :model="addForm">
          <el-form-item label="上级分类">
            <div style="display: flex">
              <el-input disabled style="width: 300px" v-model="parentName"></el-input>
              <!--              <el-button style="margin-left: 5px;" @click="switchBrand">选择</el-button>-->
            </div>
          </el-form-item>
          <el-form-item label="问题类型" style="text-align: left">
            <el-radio-group @change="switchType" v-model="addForm.type">
              <el-radio :label="1">问题编辑</el-radio>
              <el-radio :label="2">链接</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="问题名称">
            <el-input show-word-limit v-model="addForm.title" placeholder="请输入问题名称"></el-input>
            <div class="styleBox">
              <div class="item">
                <span>粗体</span>
                <a-switch
                  :disabled="seeShow"
                  :checked="styleObj.bold"
                  @change="boldChange"
                  style="margin-left:5px"
                  size="small"
                />
              </div>
              <div class="item">
                <span>文字大小</span>
                <el-select
                  style="margin-left:5px;width: 100px"
                  size="small"
                  v-model="addForm.titleFont.size"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in sizeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <el-color-picker v-model="styleObj.color" show-alpha @change="colorChange"></el-color-picker>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="addForm.type == 2" label="问题链接">
            <el-input v-model="addForm.issueText" placeholder="请输入链接"></el-input>
          </el-form-item>
          <el-form-item>
            <wangeditor v-show="addForm.type == 1" ref="wangeditor"></wangeditor>
          </el-form-item>
        </el-form>
      </a-modal>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogdel"
      width="30%"
      style="height: auto"
      :before-close="handleClose"
    >
      <span>确认删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogdel = false">取 消</el-button>
        <el-button :loading="delLoading" type="primary" @click="dodel">确 定</el-button>
      </span>
    </el-dialog>

    <!-- --------------未解决问题详情查看-------------------------   -->
    <a-modal
      width="60%"
      style="height: 100%"
      title="未解决问题描述"
      :footer="null"
      v-model="problemInfoShow"
      on-ok="handleOk"
    >
      <a-list v-loading="problemLoading" :data-source="problemInfoList">
        <a-list-item slot="renderItem" slot-scope="item, index">
          <div style="width: 100%; height: 100%">
            <a-list-item-meta :description="item.feedbacktext"></a-list-item-meta>
            <div style="width: 100%; text-align: right; font-size: 12px">反馈时间： {{ item.createTime }}</div>
          </div>
        </a-list-item>
      </a-list>
      <div style="text-align: right">
        <el-pagination
          background
          :small="true"
          @prev-click="prevClick"
          @next-click="nextClick"
          @current-change="problemPage"
          layout="prev, pager, next"
          :total="problemInfoTotal"
        ></el-pagination>
      </div>
    </a-modal>
    <!-- --------------未解决问题原因图表---------------------   -->
    <el-dialog title="未解决原因" :visible.sync="ChartShow" width="700px">
      <div v-show="ChartShow" id="myChart" style="width: 600px; height: 300px; text-align: center"></div>
    </el-dialog>
  </div>
</template>
<script>
import tinymce from '@/components/Tinymce/index.vue'
import { updata } from '@/api/activesapi'
import tree from '@/components/problem/index.vue'
import {
  getProblem,
  getProblemInfo,
  addProblem,
  delProblem,
  ProblemInfo,
  editProblemInfo,
  problemSort,
  classifyIdSearch,
  JudgmentAddProblem,
  problemStateUp,
  updateHotWord,
  ProblemAddJudgment,
  getProblemInfoList,
  getProblemThechart,
  exportFn,
  importFn
} from '@/api/help'
import wangeditor from '@/components/wangeditor/index'
import { updataimg } from '@/api/activesapi'

export default {
  components: {
    'com-tree': tree,
    tinymce,
    wangeditor
  },
  name: 'faq',
  beforeRouteEnter(to, form, next) {
    next((vm) => {
      if (to.name == 'faq') {
        if (vm.$route.query.id) {
          vm.params.id = vm.$route.query.id
          vm.initList()
        } else {
          vm.params.id = 0
          vm.initList()
        }
      }
      vm.$refs.tree.init()
    })
  },
  data() {
    return {
      styleObj: {
        bold: false,
        size: "16px",
        color: "#000000",
      },
      sizeOptions: [{
        value: '16px',
        label: '16px'
      }, {
        value: '18px',
        label: '18px'
      }, {
        value: '20px',
        label: '20px'
      }, {
        value: '22px',
        label: '22px'
      }, {
        value: '24px',
        label: '24px'
      }],
      ChartShow: false,
      problemInfoTotal: 0, //未解决问题详情数量
      busy: false,
      pageTotal: 0, //当前页总数
      canAdd: true, //是否可添加
      selectTree: '',
      seeShow: false, //查看禁用表单
      doaddloading: false, //添加按钮禁止重复提交
      classifyName: '', //所属分类
      dialogdel: false, //删除弹窗
      loading: true,
      brand: false,
      parentName: '', //父级名称
      addForm: {
        type: 2,
        title: '',
        issueText: '',
        classifyId: '',
        titleFont: {
          color: "",
          size: "",
          bold: ""
        }
      }, //新增表单
      addShow: false, //添加弹窗的显示隐藏,
      tinyText: false,
      treeValue: {},
      problemList: [],
      params: {
        id: 0,
        pageNum: 1,
        pageSize: 10,
        reorder: 0
      },
      delShow: true, //删除
      delList: [],
      editShow: false,
      sortShow: false,
      problemInfoShow: false, //展示未解决问题备注列表
      problemLoading: false,
      problemInfoList: [], //未解决问题备注列表数据
      delLoading: false,
      upLoading: false,
      downLoading: false,
      hotLoading: false,
      noHotLoading: false
    }
  },
  methods: {
    colorChange: function (value) {
      this.addForm.titleFont.color = value;
    },
    boldChange: function (value) {
      this.styleObj.bold = value;
      this.addForm.titleFont.bold = value ? "bolder" : '';
    },
    importFaq: function () {
      this.$confirm("是否下载导入问题模板？").then(res => {
        window.open('https://obs-b2b-1306055453.cos.ap-shanghai.myqcloud.com/b2b-vendor/market/pic/导入模板251632474070228.xlsx')
      }, error => {
        const iptObj = document.createElement("input");
        iptObj.setAttribute("type", "file");
        iptObj.setAttribute("id", "ipt");
        iptObj.setAttribute("style", "visibility:hidden");
        document.body.appendChild(iptObj);
        iptObj.click();
        iptObj.addEventListener("change", async e => {
          var file = e.target.files[0];
          var formdata = new FormData();
          formdata.append("file", file, file.name);
          let result = await importFn(formdata);
          if (result.status === 200 && result.data.data === "ok") {
            this.$message.success("导入成功");
            this.initList();
          } else {
            this.$message.error("导入失败")
          }
        })
      })
    },
    exportFaq: async function () {
      try {
        const { brand } = JSON.parse(window.sessionStorage.getItem("userinfo"));
        let exportResult = await exportFn();
        var blob = new Blob([exportResult.data], { type: 'application/vnd.ms-excel' }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
        var downloadElement = document.createElement('a');
        //创建下载链接
        var href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        downloadElement.download = `${brand}问题.xlsx`; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      } catch (e) {
        return this.$message.error('刷新后重试')
      }
    },
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },

    // 清除富文本内容
    closeModal() {
      setTimeout(() => {
        this.$refs.wangeditor.editHtml('')
      }, 500)
      this.addShow = false
    },
    //根据id查询图表
    openMyChart(val) {
      var option = {
        title: {},
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: []
        },
        series: [
          {
            name: '问题原因',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中 请稍等',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      getProblemThechart({ id: val.id }).then((res) => {
        loading.close()
        if (res.status == 200 && res.data.code == 0) {
          if (res.data.data.length == 0) {
            return this.$message.error('暂无未解决原因')
          }
          this.ChartShow = true
          let itemArr = []
          res.data.data.map((item) => {
            if (item.content == 1) {
              item.content = '操作步骤太多，记不住'
            } else if (item.content == 2) {
              item.content = '实际操作过程与描述内容不符，用不上'
            } else if (item.content == 3) {
              item.content = '文字太多，不想看'
            } else if (item.content == 4) {
              item.content = '不是我想看到的内容'
            } else if (item.content == 5) {
              item.content = '其他'
            }
            itemArr.push({
              name: item.content,
              value: item.number
            })
          })
          option.series[0].data = itemArr
          for (let i in res.data.data) {
            option.legend.data.push(res.data.data[i].content)
          }
          this.$nextTick(() => {
            let myChart = this.$echarts.init(
              document.getElementById('myChart')
            )
            //  绘制图表
            myChart.setOption(option)
          })
        }
      })
    },
    //---------------------------分页
    problemPage(val) {
      this.openProblemsInfo(this.problemId, val)
    },
    nextClick(val) {
      this.openProblemsInfo(this.problemId, val)
    },
    prevClick(val) {
      this.openProblemsInfo(this.problemId, val)
    },
    //打开未解决问题列表
    openProblemsInfo(val, page) {
      this.problemId = val
      this.problemInfoShow = true
      this.problemLoading = true
      let obj = {
        issue_id: val.id,
        pageNum: 1,
        pageSize: 10
      }
      if (page) {
        obj.pageNum = page
      }
      getProblemInfoList(obj).then((res) => {
        if (res.status == 200 && res.data && res.data.list) {
          console.log(res)
          this.problemInfoList = res.data.list
          this.problemLoading = false
          this.problemInfoTotal = res.data.total
        } else {
          this.$message.warning('数据获取失败')
        }
        console.log(res)
      })
    },
    //将问题设置为标红状态  1标记，2取消标记
    upHot(val) {
      if (val) {
        this.hotLoading = true
        this.upHotHttp(this.delList, '1')
      } else {
        this.noHotLoading = true

        this.upHotHttp(this.delList, '0')
      }
    },
    //标红状态请求
    upHotHttp(list, state) {
      var idList = []
      list.forEach((ele) => {
        idList.push(ele.id)
      })
      let str = idList.toString()
      let obj = {
        ids: str,
        hot: state
      }
      updateHotWord(obj).then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          this.$message.success('操作成功')
          setTimeout(() => {
            this.noHotLoading = false
            this.hotLoading = false
          }, 1000)
          this.initList()
        } else {
          setTimeout(() => {
            this.noHotLoading = false
            this.hotLoading = false
          }, 1000)
          this.$message.error('操作失败')
        }
      })
    },
    //下一页
    nextPage(val) {
      this.params.pageNum = val
      this.initList()
    },
    //上一页
    prevPage(val) {
      this.params.pageNum = val
      this.initList()
    },
    //当前选中页
    currentPage(val) {
      this.params.pageNum = val
      this.initList()
    },
    //批量上架
    upStateTop() {
      let list = []
      for (let i in this.delList) {
        list.push(this.delList[i].id)
      }
      let str = list.toString()
      this.upLoading = true
      this.upState(1, str)
    },
    //批量下架
    upStateBottom() {
      let list = []
      for (let i in this.delList) {
        list.push(this.delList[i].id)
      }
      let str = list.toString()
      this.downLoading = true
      this.upState(2, str)
    },
    upState(state, val) {
      let obj = {
        ids: val,
        state: state
      }
      problemStateUp(obj).then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          this.$message.success('操作成功')
          this.initList()
          setTimeout(() => {
            this.upLoading = false
            this.downLoading = false
          }, 1000)
        } else {
          this.$message.error('操作失败')
          setTimeout(() => {
            this.upLoading = false
            this.downLoading = false
          }, 1000)
        }
      })
    },
    //排序
    changeSort(val) {
      if (val.order == 'ascending') {
        if (val.prop == 'usolveCount') {
          this.tableSort(5)
        } else if (val.prop == 'solveCount') {
          this.tableSort(1)
        } else if (val.prop == 'inquiryCount') {
          this.tableSort(3)
        }
      } else {
        if (val.prop == 'usolveCount') {
          this.tableSort(6)
        } else if (val.prop == 'solveCount') {
          this.tableSort(2)
        } else if (val.prop == 'inquiryCount') {
          this.tableSort(4)
        }
      }
    },
    tableSort(val) {
      this.params.reorder = val
      this.initList()
    },
    // 上移下移
    tomove(index, e, val) {
      console.log(val)
      if (e) {
        this.moveuptools(index, val)
      } else {
        this.movedowntools(index, val)
      }
    },
    movedowntools(i, el) {
      let temp = null
      let arr = JSON.parse(JSON.stringify(this.problemList))
      if (i != arr.length - 1) {
        console.log('current index:', i)
        this.$confirm('是否下移?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            //找到当前元素下标
            let ids = this.problemList.findIndex((item) => item.id == el.id)
            let prev = this.problemList[ids + 1]
            console.log(el, prev)
            let listPrams = [
              {
                id: el.id,
                sort: prev.sort
              },
              {
                id: prev.id,
                sort: el.sort
              }
            ]
            let params = {
              list: JSON.stringify(listPrams)
            }
            problemSort(params).then((res) => {
              if (res.status == 200 && res.data.data == 1) {
                this.$message.success('操作成功')
                this.initList()
              } else {
                this.$message.error('操作失败')
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      } else {
        console.log('不能下移动')
        this.$notify({
          title: '警告',
          message: '到底了不能向下移动了',
          type: 'warning'
        })
      }
    },
    //上移
    moveuptools(i, el) {
      let temp = null
      let arr = JSON.parse(JSON.stringify(this.problemList))
      console.log('arr[i】', +arr[i].sort, el.sort)
      if (i >= 1) {
        this.$confirm('是否上移?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            //找到当前元素下标
            let ids = this.problemList.findIndex((item) => item.id == el.id)
            let prev = this.problemList[ids - 1]
            console.log(el, prev)
            let listPrams = [
              {
                id: el.id,
                sort: prev.sort
              },
              {
                id: prev.id,
                sort: el.sort
              }
            ]

            let params = {
              list: JSON.stringify(listPrams)
            }
            problemSort(params).then((res) => {
              console.log(res, 'asdasd')
              if (res.status == 200 && res.data.data == 1) {
                this.$message.success('操作成功')
                this.initList()
              } else {
                this.$message.error('操作失败')
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      } else {
        console.log('不能上移动')
        this.$notify({
          title: '警告',
          message: '到顶了不能向上移动了',
          type: 'warning'
        })
      }
    },
    qx() {
      this.brand = false
      this.seeShow = false
    },
    // 上架
    top(val) {
      if (val.state == 1) {
        return this.$message.error('当前已是上架状态')
      }
      this.initUp(1, val)
    }, //下架
    bottom(val) {
      if (val.state == 2) {
        return this.$message.error('当前已是下架状态')
      }
      this.initUp(2, val)
    },
    // 上下架请求
    initUp(val1, val2) {
      let obj = {
        ids: val2.id,
        state: val1
      }
      problemStateUp(obj).then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          this.$message.success('操作成功')
          this.initList()
        } else {
          this.$message.error('操作失败')
        }
      })
    },
    see(val) {
      this.seeShow = true
      this.editShow = false
      this.addShow = true
      this.addForm.type = +val.type
      this.addForm.id = val.id
      this.addForm.state = val.state
      this.addForm.issueText = val.issueText
      if (val.type == 1) {
        this.tinyText = true
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.wangeditor.editHtml(val.issueText)
          }, 500)
        })
      } else {
        this.tinyText = false
      }
      this.addForm.title = val.title;

      this.addForm.titleFont = (val.titleFont !== "" && JSON.parse(val.titleFont) || {});

      this.styleObj.bold = this.addForm.titleFont.bold ? true : false;
      getProblemInfo(val.classifyId).then((res) => {
        if (res.status == 200 && res.data && res.data.data) {
          this.parentName = res.data.data.name
          this.addForm.classifyId = res.data.data.id
        }
      })
    },
    // 编辑
    edit(val) {
      this.seeShow = false
      this.editShow = true
      this.addShow = true
      this.addForm.type = +val.type
      this.addForm.id = val.id
      this.addForm.state = val.state
      this.addForm.issueText = val.issueText
      if (val.type == 1) {
        this.tinyText = true
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.wangeditor.editHtml(val.issueText)
          }, 500)
        })
      } else {
        this.tinyText = false
      }
      this.addForm.title = val.title;
      this.addForm.titleFont = (val.titleFont !== "" && JSON.parse(val.titleFont) || {});

      this.styleObj.bold = this.addForm.titleFont.bold ? true : false;
      getProblemInfo(val.classifyId).then((res) => {
        if (res.status == 200 && res.data && res.data.data) {
          this.parentName = res.data.data.name
          this.addForm.classifyId = res.data.data.id
        }
      })
    },
    //删除
    dodel() {
      let list = []
      for (let i in this.delList) {
        if (this.delList[i].state == 2) {
          list.push(this.delList[i].id)
        }
      }
      if (list.length == 0) {
        this.$message.warning('无可删除问题')
        return (this.dialogdel = false)
      }
      this.delLoading = true

      let str = list.toString()
      delProblem(str).then((res) => {
        this.delLoading = false
        if (res && res.status == 200 && res.data.code == 0) {
          this.$message.success('删除成功')
          this.dialogdel = false
          this.delLoading = false
          this.params.id = 0
          this.initList()
        } else {
          this.delLoading = false

          this.$message.error('删除失败')
        }
      })
    },
    //删除弹窗
    godel() {
      this.dialogdel = true
    },
    //表格选中删除
    handleSelectionChange(val) {
      if (val.length == 0) {
        this.delShow = true
      } else {
        this.delShow = false
        this.delList = val
      }
    },
    async doadd() {
      if (this.addForm.type == 1) {
        await this.$nextTick(() => {
          this.addForm.issueText = this.$refs.wangeditor.getHtml()
        })
      }

      this.addForm.state = 2

      let str = JSON.parse(JSON.stringify(this.addForm))
      if (this.addShow) {
        delete str.id
      }
      for (var i in str) {
        if (this.tinyText) {
          if (str[i] == '') {
            return this.$message.error('保存失败')
          }
        } else {
          delete str.issueText
          if (str[i] == '') {
            return this.$message.error('保存失败')
          }
        }
      }
      this.doaddloading = true
      this.addForm.titleFont = this.addForm.titleFont !== "" && JSON.stringify(this.addForm.titleFont)

      // 编辑
      if (this.editShow) {
        console.log('编辑')

        editProblemInfo(this.addForm).then((res) => {
          if (res.status == 200 && res.data.data == 1) {
            this.addShow = false
            this.parentName = ''
            // for (let i in this.addForm) {
            //   this.addForm[i] = "";
            // }
            this.$message.success('保存成功')
            this.doaddloading = false
            this.initList()
          } else {
            this.$message.error('保存失败')
            this.doaddloading = false
          }
        })
      } else {
        console.log('新增')
        // 新增
        this.addForm.state = 2;
        const res = await addProblem(this.addForm)
        if (res.status == 200 && res.data.data == 1) {
          this.$message.success('保存成功')
          this.addShow = false
          this.doaddloading = false
          this.initList()
        } else {
          this.doaddloading = false
          return this.$message.error('保存失败')
        }
        this.parentName = ''
        for (let i in this.addForm) {
          this.addForm[i] = ''
        }
        this.addForm.type = 2
      }
    },
    switchBrand() {
      this.brand = true
    },
    //新增问题选择父级分类
    doSwitchBrand() {
      if (!this.treeValue.name) {
        return this.$message.error('还未选择分类')
      }
      let obj = {
        id: this.treeValue.id
      }
      JudgmentAddProblem(obj).then((res) => {
        if (res.status == 200) {
          if (!res.data.data) {
            return this.$message.error('当前分类已有下级分类，无法添加问题')
          } else {
            this.addForm.classifyId = this.treeValue.id
            this.parentName = this.treeValue.name
            this.brand = false
          }
        }
        this.$forceUpdate()
      })
    },
    switchType(e) {
      if (e == 1) {
        this.tinyText = true
      } else {
        this.tinyText = false
      }
    },
    goadd() {
      this.addForm = this.$options.data().addForm;
      this.styleObj = this.$options.data().styleObj;
      this.addForm.type = 1
      setTimeout(() => {
        this.$refs.wangeditor.editHtml('')
      }, 500)
      this.seeShow = false
      this.editShow = false
      if (!this.treeValue.name) {
        return this.$message.error('还未选择分类')
      }
      let obj = {
        id: this.treeValue.id
      }
      JudgmentAddProblem(obj).then((res) => {
        if (res.status == 200) {
          if (!res.data.data) {
            return this.$message.error('当前分类已有下级分类，无法添加问题')
          } else {
            this.addShow = true

            this.addForm.classifyId = this.treeValue.id
            this.parentName = this.treeValue.name
            this.brand = false
          }
        }
        this.$forceUpdate()
      })
    },
    initList() {
      this.loading = true
      getProblem(this.params).then((res) => {
        console.log(res, 'adasd')
        if (res.status == 200 && res.data.list) {
          this.problemList = res.data.list
          this.loading = false
          this.pageTotal = res.data.total
          this.$forceUpdate()
        }
      })
    },
    classify(val) {
      this.params.id = val.id
      getProblemInfo(val.id).then((res) => {
        if (res.status == 200 && res.data.data) {
          this.treeValue = res.data.data
        }
      })
      //判断是否展示上下移动-----------------
      ProblemAddJudgment({ id: val.id }).then((res) => {
        if (res.status == 200) {
          if (res.data.data) {
            this.sortShow = false
          } else {
            this.sortShow = true
          }
        }
      })
      this.canAdd = false
      this.params.id = val.id
      this.initList()
      //新增选择树形节点
      // if (this.brand) {
      //   this.params.id = val.id
      //   getProblemInfo(val.id).then(res => {
      //     if (res.status == 200 && res.data.data) {
      //       this.treeValue = res.data.data
      //     }
      //   })
      // } else {
      //   this.params.id = val.id;
      //   this.initList();
      // }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.addShow = false
          this.parentName = ''
          for (var i in this.addForm) {
            this.addForm[i] = ''
          }
          this.addShow = false
          this.seeShow = false
          // this.$refs.tinymce.setContent("");
          done()
        })
        .catch((_) => {
        })
    },
    // 问题分类跳转携带id获取问题
    jumpGetInfo(val) {
      this.selectTree = val //选中树节点
      this.params.id = val
      this.initList()
    }
  },
  created() {
    this.initList()
  }
}
</script>

<style scoped="scoped" lang="scss">
.styleBox {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  .item:first-child {
    margin: 0;
  }
  .item {
    margin: 0 20px;
  }
}
/deep/ .tree-container {
  max-height: 85vh;
  overflow: auto;
}
/deep/ .el-table__column-filter-trigger > i {
  font-size: 18px !important;
  font-weight: bolder;
}

/deep/ .el-table th > .cell {
  font-size: 14px;
}

.linkTip {
  width: 200px;
  white-space: nowrap;
  /*控制单行显示*/
  overflow: hidden;
  /*超出隐藏*/
  text-overflow: ellipsis;
  /*隐藏的字符用省略号表示*/
}

.linkTips {
  width: 100px;
  white-space: nowrap;
  /*控制单行显示*/
  overflow: hidden;
  /*超出隐藏*/
  text-overflow: ellipsis;
  /*隐藏的字符用省略号表示*/
}

.fromrelative {
  position: relative;
  display: inline-block;
  // z-index: 99;
  // background-color: #9e9e9e;
  margin: 0 6px;

  .formabsolive {
    width: 60px;
    // height: 100px;
    z-index: 99;
    left: -12px;
    border-radius: 5px;
    display: flex;
    flex-flow: column wrap;
    position: absolute;
    background: #f0f0f0;
    text-align: center;
    color: #363636;
    padding: 5px 0;

    .fb {
      width: 28px;
      // height: 14px;
      text-align: center;
      width: 100%;
      padding: 8px 0;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(96, 98, 102, 1);
      text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    }

    .fb:hover {
      background: rgba(245, 247, 250, 1);
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
      color: rgba(6, 134, 224, 1);
    }
  }

  //     .formabsolive:hover{
  //       background:rgba(245,247,250,1);
  //       box-shadow:0px 0px 4px 0px rgba(0,0,0,0.1);
  // font-family:PingFangSC-Medium,PingFang SC;
  // font-weight:500;
  // color:rgba(6,134,224,1);
  // line-height:14px;
  // text-shadow:0px 0px 4px rgba(0,0,0,0.1);
  //           }
}

.dialogbox /deep/ .el-dialog {
  // height: 90%;
  // min-height: 70vh;
  height: auto;
}

.brand /deep/ .el-tree {
  // background: #F5F6FD
  background-color: #f1eff2;
  // border: 1px solid #F1EFF2;
}

.brand {
  text-align: right;
  position: absolute;
  left: 50%;
  top: 10%;
  margin-left: -165px;
  z-index: 99;
  border-radius: 20px;
  background-color: #f1eff2;
  border: 1px solid #f1eff2;
  opacity: 1;
}

.active {
  background: rgba(112, 128, 144, 0.3);
}

.treebox {
  width: 320px;
  display: flex;
  justify-content: space-between;
  border-right: 1px solid #eef0f6;
}

.tableBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.header {
  width: 10%;
  justify-content: space-between;
  height: 40px;
  display: flex;
}

///deep/ .demo-infinite-container {
//  border: 1px solid #e8e8e8;
//  border-radius: 4px;
//  overflow: auto;
//  padding: 8px 24px;
//  height: 300px;
//}
///deep/ .demo-loading-container {
//  position: absolute;
//  bottom: 40px;
//  width: 100%;
//  text-align: center;
//}
</style>
